import styled, { css } from "styled-components";
import { ExpirationDateStyle } from "../../../../sharable/ExpirationDate";
import {
  CARTAZ_GRANDE,
  CARTAZ_MEDIO,
  CARTAZ_PEQUENO,
  CARTAZ_PEQUENO_DIM,
} from "../../EncarteConstants";
import { BrandLogo, Canvas, Footer, Header } from "../CanvasGeneralStyles";

const LOGO_SIZE_LARGE = 350;
const LOGO_SIZE_MEDIUM = 200;
const LOGO_SIZE_SMALL = 120;
const HEADER_HEIGHT_BY_FORMAT = {
  [CARTAZ_PEQUENO]: 200,
  [CARTAZ_MEDIO]: 265,
  [CARTAZ_GRANDE]: 535,
};
const BACKGROUND_OFFSET_BY_FORMAT = {
  [CARTAZ_PEQUENO]: -150,
  [CARTAZ_MEDIO]: -150,
  [CARTAZ_GRANDE]: -300,
};

const getHeaderHeight = (format) =>
  HEADER_HEIGHT_BY_FORMAT[format] ?? HEADER_HEIGHT_BY_FORMAT[CARTAZ_GRANDE];

const getLogoSize = (format) =>
  format === CARTAZ_GRANDE
    ? LOGO_SIZE_LARGE
    : format === CARTAZ_MEDIO
      ? LOGO_SIZE_MEDIUM
      : LOGO_SIZE_SMALL;

const getBackgroundOffset = (format) =>
  BACKGROUND_OFFSET_BY_FORMAT[format] ??
  BACKGROUND_OFFSET_BY_FORMAT[CARTAZ_GRANDE];

export const CartazHeader = styled(Header)`
  ${({ styles, canvasScale }) => css`
    height: ${getHeaderHeight(styles.format) * canvasScale}px !important;
  `}
`;

const CartazGrandeFooterStyles = css`
  ${ExpirationDateStyle} {
    ${({ canvasScale }) => css`
      font-size: ${canvasScale * 45}px;
    `}
  }
`;

export const CartazFooter = styled(Footer)`
  height: 100%;
  padding: 0;

  ${({ styles }) => styles.format === CARTAZ_GRANDE && CartazGrandeFooterStyles}
`;

export const ProductWrapper = styled.div`
  height: 100%;
`;

export const CartazPequenoStyles = css`
  ${({ canvasScale }) => css`
    width: ${CARTAZ_PEQUENO_DIM.width * canvasScale}px;
    height: ${CARTAZ_PEQUENO_DIM.height * canvasScale}px;
    background-position-y: ${-100 * canvasScale}px;
    ${BrandLogo} {
      border-width: ${5 * canvasScale}px;
    }
  `}
  overflow: visible;
  transform: rotate(-90deg);
`;

export const CartazCanvasContainer = styled(Canvas)`
  width: 100%;
  height: 100%;
  box-shadow: none;
  grid-template-rows: min-content 1fr min-content;
  ${({ canvasScale, styles }) => css`
    margin-top: 0;

    ${BrandLogo} {
      width: ${canvasScale * getLogoSize(styles.format)}px;
      height: ${canvasScale * getLogoSize(styles.format)}px;
    }

    background-position-y: ${getBackgroundOffset(styles.format) *
    canvasScale}px;
  `}

  background-size: cover;
  padding: 0;
  ${({ styles }) => styles.format === CARTAZ_PEQUENO && CartazPequenoStyles}
`;
